// Client build-time config (Vite env). Every service is optional: without it the game is a
// fully offline single-player game, exactly as before.
const e = import.meta.env;

export const clientEnv = {
  apiUrl: (e.VITE_API_URL as string | undefined) || (location.hostname === "localhost" ? "http://localhost:8787" : ""),
  privyAppId: (e.VITE_PRIVY_APP_ID as string | undefined) || "",
  devAuth: e.VITE_DEV_AUTH === "1",
  posthogKey: (e.VITE_POSTHOG_KEY as string | undefined) || "",
  posthogHost: (e.VITE_POSTHOG_HOST as string | undefined) || "https://eu.i.posthog.com",
  sentryDsn: (e.VITE_SENTRY_DSN as string | undefined) || "",
  appEnv: (e.VITE_APP_ENV as string | undefined) || (e.DEV ? "development" : "production"),
};

export const online = () => !!clientEnv.apiUrl;
